// @ts-check
import React, { useState } from 'react';
import PropertiesConditionEditor from 'components/Condition/PropertiesCondition/PropertiesConditionEditor';

const PropertiesConditionEditorExample = () => {
  const [conditions, setConditions] = useState([]);

  return (
    <PropertiesConditionEditor conditions={conditions} onConditionsChanged={setConditions} />
  );
};

export default PropertiesConditionEditorExample;
